import React, { useState } from 'react'
import Title from '../../../components/Title/Title';
import { Col, Container, Row } from 'react-bootstrap';
import EventCard from '../../../components/EventCard';
import Button from '../../../components/Button';
import SectionHeader from '../../../components/SectionHeader';

function ServicesAndBenefit(props) {



    return (
        <>

            <div className="services-and-benfits">

            </div>
            <div className="container-fluid2 bg2 ">
                <Title options={{ "title": "Services & Benefits | EFH Online ICSE & CBSE Tuition", "description": "EFH services and benefits: HD recorded lessons, multilingual videos, live doubt-clearing, and 24/7 support for ICSE and CBSE Computer Science students.", "image": "", "url": "" }} />

                <div className="container sectionheader ">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card p-3'>
                                <h2 className="text-center fw-bold mb-4" style={{ fontSize: "250%" , lineHeight: "2" }}>Our <span className="text-primary">Services & Benefits</span></h2>
                                <ol className="" style={{ fontSize: "130%" , lineHeight: "2" }}>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Personalised account</span> for tracking overall performance, grades, assignments, progress, and tips for improvement for each student.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">High-definition recorded videos</span> with written texts and audio of the teacher.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Multi-lingual instructional videos</span> available in all Indian regional languages.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Live meeting with teacher</span> every month to clarify doubts.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">24/7 ChatGPT support</span> to answer questions from students. Provision of a mail/call set up with the teacher directly, in case ChatGPT is unable to solve the question.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Additional questions</span> for students struggling to answer module questions.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Personalised question banks</span> created by the teacher herself.
                                    </li>
                                </ol>




                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};


export default ServicesAndBenefit;
